import styled from 'styled-components';

const MultiValueContainer = styled.div`
  position: relative;
`;

const AutomationDot = styled.div`
  background: var(--color-info-default, #006fff);
  border-radius: 100%;
  height: 10px;
  left: -2px;
  position: absolute;
  top: -2.5px;
  width: 10px;
`;

export { AutomationDot, MultiValueContainer };
